import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { getGroupState } from "state/slices/group-slice";
import {
  fetchContests,
  fetchUserContests,
  getContestsState,
  getNonDeletedContests,
  setContestsStale,
  setUserContestsStale
} from "state/slices/contests-slice";
import { useAuth } from "hooks/auth";
import { getIntegratedAppState, IntegratedAppState } from "state/slices/integrated-app-slice.ts";

const useContestData = () => {
  const dispatch = useAppDispatch();
  const group = useAppSelector(getGroupState);
  const integratedAppState = useAppSelector(getIntegratedAppState);

  const groupId = group.id;
  const {
    joinedContests,
    loadingUserContests,
    loadingContests,
    contestsStale,
    userContestsStale,
  } = useAppSelector(getContestsState);
  const contests = useAppSelector(getNonDeletedContests);
  const auth = useAuth();

  useEffect(() => {
      if (!groupId ||
        !contestsStale ||
        !group.isContestGroup) {
        return;
      }

      dispatch(fetchContests(groupId));
      dispatch(setContestsStale(false));
    },
    [dispatch, groupId, contestsStale, group.isContestGroup, integratedAppState.state]);

  useEffect(() => {
    if (!groupId ||
      !auth.signedIn ||
      !userContestsStale ||
      !group.isContestGroup ||
      (integratedAppState.state === IntegratedAppState.UNDEFINED ||
        integratedAppState.state === IntegratedAppState.INTEGRATED_SESSION_INITIALIZING)) {
      return;
    }

    dispatch(fetchUserContests(groupId));
    dispatch(setUserContestsStale(false));
  }, [dispatch, groupId, auth.signedIn, userContestsStale, group.isContestGroup, integratedAppState.state]);


  const isContestLoading = auth.signedIn ? loadingContests || loadingUserContests : loadingContests;

  return {
    contests,
    joinedContests,
    loading: group.isContestGroup ? isContestLoading : false,
    loadingUserContests: loadingUserContests,
    loadingContests: loadingContests,
    refetchUserContests: () => {
      dispatch(setUserContestsStale(true));
      dispatch(setContestsStale(true));
    }
  };
};

export default useContestData;
